export default __webpack_public_path__ + "static/media/tips.6438ec71.svg";